import SchemeDrawingModal from '&/components/SchemeDrawing/modal';

export default function DrawingCommentModal() {
    return <SchemeDrawingModal />;
}
